module.exports = __webpack_public_path__ + "images/external_images/img/demo/hotel/room-3.jpg";